<script>
	import bigImage from '$lib/images/shop/big-image.jpg';
	import FilesLarge from '$lib/images/svg/files-large.svelte';
	import StorageLarge from '$lib/images/svg/storage-large.svelte';
	import SlovakiaLarge from '$lib/images/svg/slovakia-large.svelte';
	import EshopLinkBoxes from '../(components)/EshopLinkBoxes.svelte';
	import Heading from '../(components)/Heading.svelte';
	import Breadcrumb from '../../components/Breadcrumb.svelte';
	import OurAdvantages from '../(components)/OurAdvantages.svelte';
	export let data;
</script>

<svelte:head>
	<title>Eshop Scootland rychlý jak šlak</title>
	<meta name="description" content="Vyberte skútr a zobrazte díly, které 100% pasují. Skladem odesíláme ihned, zboží dorazí rychle. Prodáváme i na Slovensko."/>
	<meta name="keywords" content="zboží, produkty, nabídka, výrobci, dostupnost, expedice, zabalení" />
	<link rel="canonical" href={'https://www.scootland.cz/eshop/'} />
	<meta property="og:title" content="Eshop Scootland rychlý jak šlak" />
	<meta property="og:description" content="Vyberte skútr a zobrazte díly, které 100% pasují. Skladem odesíláme ihned, zboží dorazí rychle. Prodáváme i na Slovensko."/>
	<meta property="og:image" content="/image/og-eshop.webp"/>
	<meta property="og:url" content="https://www.scootland.cz/eshop/"/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
</svelte:head>

<Breadcrumb breadcrumbs={[{ name: 'Eshop', link: '/eshop' }]} />

<div class="container mx-auto mb-8 mt-5 text-center md:mb-12 md:mt-10">
	<Heading tag="h1" size="md" class="mb-4">Navštivte náš e-shop</Heading>
	<p class="text-base leading-loose">
		Náhradní díly i pro váš skútr! Zvolte jednu ze dvou možností a vstupte do e-shopu:
	</p>
</div>

<div class="container mx-auto mb-8 px-2.5 md:mb-16">
	<EshopLinkBoxes class="mb-12 md:mb-16" />
</div>

<img src={bigImage} alt="" class="container mx-auto" />

<div
	class="container mx-auto mb-12 mt-8 flex flex-col gap-y-10 px-2.5 text-center md:my-16 md:grid md:grid-cols-3 md:gap-x-16"
>
	<div class="flex flex-col items-center">
		<StorageLarge class="mb-6 w-24" />
		<Heading tag="h3" size="sm" class="mb-3">Doručení už od druhého pracovního dne</Heading>
		<p class="leading-loose">Osobní odběr v Brně a na výdejních místech po celé České republice</p>
	</div>

	<div class="flex flex-col items-center">
		<FilesLarge class="mb-6 w-24" />
		<Heading tag="h2" size="sm" class="mb-3">Široká nabídka náhradních dílů</Heading>
		<p class="leading-loose">
			Nabízíme nové i použité náhradní díly na všechny skútry. Na konkrétní značky můžeme poskytnout
			také originální díly.
		</p>
	</div>

	<div class="flex flex-col items-center">
		<SlovakiaLarge class="mb-6 w-24" />
		<Heading tag="h2" size="sm" class="mb-3">Zasíláme i na Slovensko</Heading>
		<p class="leading-loose">Zaslání náhradních dílů na Slovensko do 24 hodin pro nás není problém!</p>
	</div>
</div>

<div class="bg-gray-alabaster px-2.5 pb-10 pt-12 text-center md:py-16">
	<div class="container mx-auto">
		<Heading tag="h2" size="md" class="mb-3 text-xl md:text-2xl">Vyberte svou značku</Heading>
		<p class="mb-10 leading-loose">
			Nabídku stále aktualizujeme a můžeme ji tak lépe přizpůsobit vašim požadavkům.
		</p>
		<div class="flex flex-row flex-wrap justify-center gap-y-5 text-red md:text-center">
			{#each data?.producers as producer}
				<a class="mx-2" href="/vyrobci/{producer.slug}/" title="Veškeré náhradní díly od výrobce {producer.name} v nabídce Scootland">{producer.name}</a>
			{/each}
		</div>
	</div>
</div>

<OurAdvantages class="bg-white" />
